import { AppConfigService } from '../app-config/app-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Catalog } from '../../models/catalog-dto';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

@Injectable({
  	providedIn: 'root'
})

export class HttpGetCatalogService {

    public readonly URL: string;

	constructor(
		private http: HttpClient,
        private configSvc: AppConfigService
	) {
        this.URL = this.configSvc.settings.apiUrl + 'v1alpha/catalog/query';
    }

	public obtain$(): Observable<Catalog[]> {

		const body = {
			"@context": {
				"@vocab": "https://w3id.org/edc/v0.0.1/ns/"
			},
			"@type": "QuerySpec"
		};

		const headers = new HttpHeaders({
			'x-api-key': this.configSvc.settings.catalogAPIKey,
			'Content-Type': 'application/json'
		});

		return this.http.post<Catalog[] | Catalog>(
			this.URL,
			body,
			{ headers }
		).pipe(
			map((response: Catalog[] | Catalog) =>
				Array.isArray(response) ? response : [response])
		);

	}

}